// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"be2a9c93","180":"65ded289","233":"4a8a48a3","315":"5354194f","381":"aedd1e72","453":"30866073","515":"7f2c01b6","985":"1a3cdf10"}[chunkId] + ".chunk.js";
};